import { type ClassValue, clsx } from "clsx";

// const twMerge = extendTailwindMerge({ extend: { theme: { text: ["heading-page", "heading-section", "heading-card", "heading-sub", "body", "body-lg", "caption", "label", "data", "badge", "kpi"] } } });
export function cn(...inputs: ClassValue[]) {
    return clsx(inputs);
}
